import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { IEditableInline } from 'src/app/api/ieditable-inline';
//import { IPerformanceBodCentralTankBattery } from 'src/app/api/performance-bod-central-tank-battery';
import { IPerformanceBodSateliteFacility } from 'src/app/api/performance-bod-satelite-facility';
import { InlineEditService } from 'src/app/services/inline-edit.service';
import { PerformanceBodDataService } from 'src/app/services/performance-bod-data.service';
import { PerformanceBodStoreService } from 'src/app/services/performance-bod-store.service';

@Injectable({
  providedIn: 'root',
})
export class PerformanceBodSateliteFacilityService extends InlineEditService implements IEditableInline {
  public data: IPerformanceBodSateliteFacility[] = [];
  public originalData: IPerformanceBodSateliteFacility[] = [];
  public createdItems: IPerformanceBodSateliteFacility[] = [];
  public updatedItems: IPerformanceBodSateliteFacility[] = [];
  public deletedItems: IPerformanceBodSateliteFacility[] = [];
  public performanceBodId: string;

  constructor(
    private performanceBodDataService: PerformanceBodDataService
  ) {
    super();
  }

  public isNew(item: any): boolean {
    return !item.id;
  }

  public itemIndex(item: any, data: IPerformanceBodSateliteFacility[]): number {
    for (let idx = 0; idx < data.length; idx++) {
      if (data[idx].id === item.id) {
        return idx;
      }
    }
    return -1;
  }

  public create(): Observable<any> {
    return this.performanceBodDataService.createPerformanceBodSateliteFacility(this.createdItems);
  }

  public retrieve(): Observable<IPerformanceBodSateliteFacility[]> {
    return this.performanceBodDataService.getPerformanceBodSateliteFacility(this.performanceBodId).pipe(map(data => {
      return data;
    }));
  }

  public update(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodSateliteFacility(this.updatedItems);
  }

  public delete(): Observable<any> {
    return this.performanceBodDataService.updatePerformanceBodSateliteFacility(this.deletedItems);
  }

  public facilityNameDuplicated(
    facilityNameA: string,
    facilityNameB: string,
    padsIdA: string,
    padsIdB: string
  ): boolean {
    if (facilityNameA.trim() === facilityNameB.trim() && padsIdA === padsIdB) {
      return true;
    } else {
      return false;
    }
  }
}
